module.exports = __webpack_public_path__ + "static/media/intro_bg_mobile.e58453ba.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Twitch/Intro/img/intro_bg_mobile.mp4
// module id = 212
// module chunks = 0